import { render, staticRenderFns } from "./SafetyHealth.vue?vue&type=template&id=24d9a27e&scoped=true"
import script from "./SafetyHealth.vue?vue&type=script&lang=js"
export * from "./SafetyHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d9a27e",
  null
  
)

export default component.exports